import React from "react";
import dataPanel from "../../../service/dataPanel.json";
import CardBgnNone from "../../../utility/templete/cardbgnNone";
const DescriptionReseller = () => {
  return (
    <div>
      <div className="container">
        <div className="row ">
          {dataPanel.descriptionPanelReseller.map((p) => (
            <CardBgnNone
              maxWidth={22}
              title={p.title}
              description={p.description}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default DescriptionReseller;
